import React from "react";
import { NumericFormat } from "react-number-format";
import { Field } from "formik";
import { InputContainer } from "styles/components/AnimatedInput";

const NumberInput = (props) => {
  const blurHandler = (evt) => {
    props?.calllBack && props?.calllBack(evt.target.value)
  }

  const lotsInput = (inputObj) => {
    const { value } = inputObj;
    if (value >= 0 && value <= 10) return true;

    return false;
  };

  const maxQuantityValue = (inputObj, name) => {
    const { value } = inputObj;
    if (value >= 0 && value <= maxQuantity) return true;

    return false;
  };

  let maxQuantity
  if (props?.maxQuantity) {
    maxQuantity = props?.maxQuantity
  }

  const quantityInput = (inputObj) => {
    const { value } = inputObj;
    if (value >= 0 && value <= parseInt(maxQuantity)) return true;

    return false;
  };

  return (
    <Field name={props?.name}>
      {({ field, meta, form }) => (
        <InputContainer className={props.className}>
          <div className="input-container">
            <NumericFormat
              autoComplete="off"
              prefix={props?.prefix}
              suffix={props?.suffix}
              placeholder={props?.displayFloatingLabel === false ? props?.placeholder : (props.displayPlaceholder ? props.placeholderValue : undefined)}
              format={props?.format}
              fixedDecimalScale={props?.fixedDecimalScale}
              decimalScale={props?.decimalScale}
              displayType={props?.displayType}
              disabled={props?.disabled}
              allowNegative={false}
              thousandSeparator={props?.thousandSeparator}
              allowedDecimalSeparators={props?.allowedDecimalSeparators}
              minLength={props?.minLength}
              maxLength={props?.maxLength}
              mask={props?.mask}
              allowLeadingZeros={true}
              onBlurCapture={blurHandler}
              isAllowed={props?.name === "lots" ? lotsInput : props?.name === "QuantityLot" ? quantityInput : maxQuantity?maxQuantityValue:false}
              onValueChange={(e) => {
                form.setFieldValue(props?.name, e.value);
                props?.onChangeHandler && props?.onChangeHandler(e.value)
                props?.calllBack && props?.calllBack(e.value, "keyDown")
              }}
              name={field.name}
              className={`${meta.touched && meta.error ? "error" : ""}`}
              {...field}
              value={props?.value !== undefined && props?.value !== null ? props?.value : field.value}
            />
            {meta.touched && meta.error && !props?.disabled && (
              <p name={props?.name + "Error"} className="error-message">{meta.error}</p>
            )}

            {props?.displayFloatingLabel !== false && (
              <label className={(field.value !== undefined && field.value !== null && field.value !== "" && field.value !== false) ? 'filled' : ''} htmlFor={props?.name}>
                {props?.placeholder}
              </label>
            )}
          </div>
        </InputContainer>
      )}
    </Field>
  );
}
export default NumberInput;

